module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login-wrap"
  }, [_c('n3-form', {
    ref: "form",
    staticClass: "login-form"
  }, [_c('h3', [_vm._v("系统登录")]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('n3-input', {
    staticClass: "field",
    attrs: {
      "placeholder": "账号",
      "width": "320px"
    },
    model: {
      value: (_vm.account),
      callback: function($$v) {
        _vm.account = $$v
      },
      expression: "account"
    }
  }), _vm._v(" "), _c('n3-input', {
    staticClass: "field",
    attrs: {
      "type": "password",
      "placeholder": "密码",
      "width": "320px"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.check($event)
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('n3-checkbox-group', {
    staticClass: "save-account",
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }, [_c('n3-checkbox', {
    attrs: {
      "label": "remember"
    }
  }, [_vm._v("记住账号")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "submit"
  }, [_c('n3-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.check($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loading ? '登录中' : '登录') + "\n      ")])], 1)]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "J_loginBackground"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dde9703!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login.vue
// module id = 311
// module chunks = 3